import React from 'react';
import { Box } from '@trp-individual-investor-adv-svc/ii-prosp-components';

import ClientAgrPanel from '../../ConsentComponents/ClientAgrPanel';
import EDeliveryPanel from '../../ConsentComponents/EDeliveryPanel';
import KeyPointsPanel from '../../ConsentComponents/KeyPointsPanel';
import ProspectusPanel from '../../ConsentComponents/ProspectusPanel';
import ExpansionPanelConsent from '../../shared/ExpansionPanelConsent';

const EDeliveryContent = ({
    formCompletion,
    isLoading,
    inProgress,
    isCustomerWebView,
    handleChange,
    prospectusesDisplay,
    checkError
}) => {

    return (
        <Box sx={{ paddingBottom: '48px' }} id='e-delivery-consent-panels-container'>
            <ExpansionPanelConsent>
                <KeyPointsPanel
                    panelNum='I'
                    open
                    handleChange={handleChange}
                    checkError={checkError}
                />
                <br />
                <EDeliveryPanel
                    panelNum='II'
                    open
                    handleChange={handleChange}
                    checkError={checkError}
                />
                <br />
                <ProspectusPanel
                    panelNum='III'
                    prospectusesDisplay={prospectusesDisplay}
                    showCheckbox
                    includeHeader
                    open
                    handleChange={handleChange}
                    checkError={checkError}
                />
                <br />
                <ClientAgrPanel
                    panelNum='IV'
                    onClick={formCompletion}
                    inProgress={inProgress || isLoading}
                    open
                    checkBox
                    handleChange={handleChange}
                    checkError={checkError}
                    isCustomerWebView={isCustomerWebView}
                />
            </ExpansionPanelConsent>
        </Box>
    );
};

export default EDeliveryContent;
